/*
 * @Description: 个体
 * @Date: 2020-10-14 15:58:13
 * @LastEditors: Please set LastEditors
 */

import { agentManager } from '@/api/ajax';
import fields, { createDownloadName } from './fields';
import search from './search';
import TableRenderClass from '@/components/tableRender/tableRenderClass';

let example = new TableRenderClass({ fields, search });

let part = example.createPart({
  name: '个体',
  search: [
    'projectName',
    'operator',
    'userEnterpriseName',
    'phone',
    'industryEnterpriseIdForGeti',
    'userTagForGeti',
    'authStatus',
    'isComplete',
    'settledStatus',
    'agentStatus',
    'estimateSettlementTime'
  ],
  list: agentManager.agentList,
  defaultQueryHotfix: { userType: 2, taxCollectionPattern: 5 },
  requestNow: true,
  fields: [
    'index',
    'operator',
    'enterpriseName',
    // 'occupationAuthStatus',// 所有园区个体去掉职业认证
    'phone',
    'realNameStatus',
    'userTag',
    'createDt',
    'historyProject',
    'submitNum',
    'taskSumSurplus',
    'passingTaskSumPlatform',
    'passTaskSumPlatform',
    'passingTaskSum',
    'noFinishTaskSum',
    'taskSumNoFinishPrice',
    'userAmount',
    'prePurchaseProsces',
    'projectSet'
  ],
  moreBtnArr: [createDownloadName({ userType: 2 })]
});

export default part;
